import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sidewidget',
  templateUrl: './sidewidget.component.html',
  styleUrls: ['./sidewidget.component.scss']
})
export class SidewidgetComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
